import { PostcardPrintOnlyCount } from '~/tenants/bre/performable/print/postcards/printonly/BrePostcardsPrintOnlyConfig';

type CountMap = Record<PostcardPrintOnlyCount, string>;

export const BrePostcardsPrintOnlyRate: CountMap = {
  50: '150',
  100: '175',
  200: '225',
  250: '255',
  500: '370',
};

export const BrePostcardsPrintOnlyPay: CountMap = {
  50: '130',
  100: '150',
  200: '195',
  250: '220',
  500: '320',
};
